import {
	Menu,
	MenuItem,
	ListItemIcon,
	ListItemText,
	Divider,
} from '@mui/material'

export default function KebabMenu({
	anchorEl,
	open,
	onClose,
	items = [],
	index = 1,
}) {
	const menu_style = {
		'& .MuiPaper-root': {
			boxShadow: '0px 0px 4px 0px #00000040',
			border: '1px solid #DFE4EB',
			borderRadius: '12px',
			minWidth: '148px',
		},
		'& .MuiList-root': {
			padding: '6px 0 !important',
		},
		'& .MuiTypography-root': {
			fontSize: '14px',
			fontWeight: '500',
			color: '#313131',
			fontFamily: 'Inter',
			textTransform: 'capitalize',
		},
		'& .MuiListItemIcon-root': {
			minWidth: '20px !important',
			width: '20px !important',
			height: '20px !important',
			marginRight: '8px',
		},
		'& .MuiDivider-root': {
			margin: '0 !important',
		},
	}
	const showDivider = (idx) => {
		if (index) return idx === index
		return idx == index || idx === items.length - 2
	}
	return (
		<Menu
			anchorEl={anchorEl}
			open={open}
			onClose={onClose}
			onClick={(e) => e.stopPropagation()}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
			transformOrigin={{ vertical: 'top', horizontal: 'right' }}
			sx={menu_style}
		>
			{items.map((it, index) => (
				<div key={it.key}>
					<MenuItem
						// key={it.key}
						onClick={() => {
							it.onClick?.()
							onClose?.()
						}}
						sx={it.color ? { color: it.color } : undefined}
						data-cy={`kebab-${it.key}`}
					>
						{it.icon && (
							<ListItemIcon
								sx={it.color ? { color: it.color } : undefined}
							>
								{it.icon}
							</ListItemIcon>
						)}
						<ListItemText>{it.label}</ListItemText>
					</MenuItem>
					{showDivider(index) && <Divider />}
				</div>
			))}
		</Menu>
	)
}
